.legacyDashboardStickyHeader {
  position: sticky;
  top: 60px;
  z-index: 1090;
  width: 100%;
  background: #fff;
  box-shadow: 0 5px 15px 0 rgb(0 0 0 / 10%);
  transition: top 0.3s ease;
}

.legacyDashboardStickyHeader[data-sticky-visible='false'] {
  top: 0;
}

.legacyHeaderSignIned.isCompact + .legacyCompatDashboardMain .legacyDashboardStickyHeader {
  top: 0;
}

.legacyDashboardStickyHeaderContent {
  width: 100%;
  margin: 0 auto;
}

:root.dark .legacyDashboardStickyHeader {
  background-color: var(--lms-color-surface-card);
  box-shadow: 0 5px 15px 0 color-mix(in srgb, var(--lms-color-ink-strong) 12%, transparent);
}
